require("stylesheets/components/exampleInput.scss");

var chroma = require("chroma-js");

var {EventGenerator} = require("../eventGenerator.js"),
    {OhmGrammarTextEditor} = require("../grammarEnabledTextEditor/ohmGrammarTextEditor.js"),
    {SaveButton} = require("../buttons/saveButton.js");

var {grammar, semantics} = require("../../language.js");

class ExampleInput extends EventGenerator {
  constructor(exampleInput, {example}){
    super();
    this.dom = exampleInput;
    this.editor = new OhmGrammarTextEditor(exampleInput.querySelector('editor'), {
      body: example, grammar
    });

    this.saveButton = new SaveButton();
    this.dom.appendChild(this.saveButton.domNode);

    this.editor.settledChangeListeners.push((valid)=> this._onSettledChange(valid));
    this.editor.changeListeners.push((valid)=> this._onChange(valid));
  }

  _onChange(){
    this.saveButton.saved = false;
  }

  _onSettledChange(valid){
    if(!valid){
      this.editor.domNode.style.backgroundColor = chroma.hsl(6, 0.98, 0.89).brighten(0.5).css();
    } else {
      this.editor.domNode.style.backgroundColor = 'initial';
      this.saveButton.saved = true;

      this._sendEvent('exampleChanged', {example: this.editor.editor.getValue()});
    }
  }
}

var toExport = {
  ExampleInput
};

if(typeof module !== "undefined" && typeof module.exports !== "undefined"){
  module.exports = toExport;
} else {
  Object.assign(window, toExport);
}



/** WEBPACK FOOTER **
 ** ./src/components/exampleRepresentation/exampleInput.js
 **/